var map = {
	"./01.webp": "./src/assets/img/01.webp",
	"./admita-que-e-pecador.png": "./src/assets/img/admita-que-e-pecador.png",
	"./apple-icon.png": "./src/assets/img/apple-icon.png",
	"./asc.gif": "./src/assets/img/asc.gif",
	"./avatar-01.webp": "./src/assets/img/avatar-01.webp",
	"./avatar-02.webp": "./src/assets/img/avatar-02.webp",
	"./avatar-03.webp": "./src/assets/img/avatar-03.webp",
	"./avatar-04.webp": "./src/assets/img/avatar-04.webp",
	"./avatar-05.webp": "./src/assets/img/avatar-05.webp",
	"./avatar-06.webp": "./src/assets/img/avatar-06.webp",
	"./bg.gif": "./src/assets/img/bg.gif",
	"./bitcoin.png": "./src/assets/img/bitcoin.png",
	"./blob.png": "./src/assets/img/blob.png",
	"./cercuri.png": "./src/assets/img/cercuri.png",
	"./chester-wade.jpg": "./src/assets/img/chester-wade.jpg",
	"./conectados.png": "./src/assets/img/conectados.png",
	"./conectados_clara.webp": "./src/assets/img/conectados_clara.webp",
	"./confesse-jesus-biblia.png": "./src/assets/img/confesse-jesus-biblia.png",
	"./confie-em-jesus.png": "./src/assets/img/confie-em-jesus.png",
	"./darken-night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png": "./src/assets/img/darken-night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png",
	"./denys.jpg": "./src/assets/img/denys.jpg",
	"./desc.gif": "./src/assets/img/desc.gif",
	"./dots.png": "./src/assets/img/dots.png",
	"./ele-vive.png": "./src/assets/img/ele-vive.png",
	"./en.png": "./src/assets/img/en.png",
	"./etherum.png": "./src/assets/img/etherum.png",
	"./fabien-bazanegue.jpg": "./src/assets/img/fabien-bazanegue.jpg",
	"./fale-com-Deus.png": "./src/assets/img/fale-com-Deus.png",
	"./fale-de-Cristo.png": "./src/assets/img/fale-de-Cristo.png",
	"./favicon.png": "./src/assets/img/favicon.png",
	"./github.svg": "./src/assets/img/github.svg?ecc2",
	"./google.svg": "./src/assets/img/google.svg?ec5e",
	"./he-live.png": "./src/assets/img/he-live.png",
	"./igreja.png": "./src/assets/img/igreja.png",
	"./img_3115.jpg": "./src/assets/img/img_3115.jpg",
	"./james.jpg": "./src/assets/img/james.jpg",
	"./julie.jpeg": "./src/assets/img/julie.jpeg",
	"./landing-page.png": "./src/assets/img/landing-page.png",
	"./leia-a-biblia.png": "./src/assets/img/leia-a-biblia.png",
	"./logo.png": "./src/assets/img/logo.png",
	"./lora.jpg": "./src/assets/img/lora.jpg",
	"./mark-finn.jpg": "./src/assets/img/mark-finn.jpg",
	"./mike.jpg": "./src/assets/img/mike.jpg",
	"./mudar-sua-mente.png": "./src/assets/img/mudar-sua-mente.png",
	"./night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png": "./src/assets/img/night-sky-full-of-stars-fantasy-animation-made-of-magical-sparkly-light-particles-flickering-on-a-purple-blue-gradient-background_bajacpz7x_thumbnail-full01.png",
	"./nucleo-logo.svg": "./src/assets/img/nucleo-logo.svg",
	"./ore.png": "./src/assets/img/ore.png",
	"./path1.png": "./src/assets/img/path1.png",
	"./path2.png": "./src/assets/img/path2.png",
	"./path3.png": "./src/assets/img/path3.png",
	"./path4.png": "./src/assets/img/path4.png",
	"./path5.png": "./src/assets/img/path5.png",
	"./patrat.png": "./src/assets/img/patrat.png",
	"./profile-page.png": "./src/assets/img/profile-page.png",
	"./pt_br.png": "./src/assets/img/pt_br.png",
	"./ripp.png": "./src/assets/img/ripp.png",
	"./ryan.jpg": "./src/assets/img/ryan.jpg",
	"./square-purple-1.png": "./src/assets/img/square-purple-1.png",
	"./square1.png": "./src/assets/img/square1.png",
	"./square2.png": "./src/assets/img/square2.png",
	"./square3.png": "./src/assets/img/square3.png",
	"./square4.png": "./src/assets/img/square4.png",
	"./square5.png": "./src/assets/img/square5.png",
	"./square6.png": "./src/assets/img/square6.png",
	"./triunghiuri.png": "./src/assets/img/triunghiuri.png",
	"./waves.png": "./src/assets/img/waves.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*$";